var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCancelOptOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99935 1.66406C5.41602 1.66406 1.66602 5.41406 1.66602 9.9974C1.66602 14.5807 5.41602 18.3307 9.99935 18.3307C14.5827 18.3307 18.3327 14.5807 18.3327 9.9974C18.3327 5.41406 14.5827 1.66406 9.99935 1.66406ZM13.916 12.7474L12.7493 13.9141L9.99935 11.1641L7.24935 13.9141L6.08268 12.7474L8.83268 9.9974L6.08268 7.2474L7.24935 6.08073L9.99935 8.83073L12.7493 6.08073L13.916 7.2474L11.166 9.9974L13.916 12.7474Z",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCancelOptOut);
export default __webpack_public_path__ + "static/media/ic_cancel-opt-out.9ad4570df4d7dca09786272f88d0001e.svg";
export { ForwardRef as ReactComponent };